import React, { useEffect, useState } from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";
import {
  BodyContainer,
  ButtonAdd,
  Header,
  TopGrid,
} from "../../components/styles";
import DataTable from "react-data-table-component";
import Loader from "react-spinners/ClipLoader";
import { useLocation, Link } from "react-router-dom";
import BackIcon from "../../images/undo.svg";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import PaymentsIcon from "@mui/icons-material/Payments";
import AddCash from "./AddCash";
import AddDeposit from "./AddDeposit";
import { CashBox, DTtitle } from "./styles";
import Repo from "../../Repository/Repo";
import moment from "moment";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import DeleteDialog from "../../components/reusableComponents/DeleteDialog";
import ResetDialog from "../../components/reusableComponents/DeleteDialog";
import { Toast } from "../../components/reusableComponents/ToastComp";

import UpdateBankDetails from "./UpdateBankDetails";

function BankDetails() {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [modal, setModal] = useState(false);
  const [bankDetails, setBankDetails] = useState([]);
  const [balance, setBalance] = useState(location?.state?.bank?.balance || 0);
  const [remModal, setRemModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [editModal, setEditModal] = useState(false);
  const [records, setRecords] = useState([]);
  const [resetModal,setResetModal] = useState(false);

console.log('rem', remModal)
console.log('b', bankDetails)

  const columns = [
    {
      name: "From",
      selector: (row) => row?.from,
    },
    {
      name: "To",
      selector: (row) => row?.to,
    },
    {
      name: "Credit",
      selector: (row) => row?.credit,
    },
    {
      name: "Debit",
      selector: (row) => row?.debit,
    },

    {
      name: "Date",
      selector: (row) => moment.unix(row?.created_at).format("DD-MM-YYYY"),
    },
    {
      name: "Action",
      cell: (row) => {
        return (
          <Stack direction="row" alignItems="center" spacing="16px">
            {/* <InfoIcon
              sx={{ color: "#4eaf51" }}
              onClick={() => handleEdit(row, "details")}
            /> */}
            <BorderColorIcon
              sx={{ color: "#4eaf51" }}
              onClick={() => editToggle(row)}
            />
            <DeleteForeverIcon
              sx={{ color: "#D35353" }}
               onClick={() => handleEdit(row, "remove")}
            />
          </Stack>
        );
      },
    },
  ];

  useEffect(() => {
    if (location?.state?.bank) {
      getBankDetails();
      getBankRecords();
    }
  }, []);
console.log('reco', records)
  console.log('loc', location.state.bank._id)
  console.log('location', location)

  const totalSumOfRecords = records?.find(item => location.state.bank._id === item._id)?.balance;

   console.log(',,,,', totalSumOfRecords)
  const remToggle = () => {
    setRemModal((prev) => !prev);
  };

  const resetToggle = () => {
    setResetModal((prev) => !prev);
  };

    const handleResetBank = async () => {
      try {
        setLoading(true);
        let { data } = await Repo.banks({
         request: {
          method: "resetBank",
          data: {
            _id: location.state.bank._id
          }
      }
        });
        setLoading(false);
        if (data.response.status.statusCode == 200) {
           setRecords(data.response.data.banks);
           getBankDetails();
           getBankRecords();
          resetToggle() 
          Toast("success", `${location.state.bank.bankName}Data Reset`);
          
        }
      } catch (err) {
        console.log("err:", err);
        setLoading(false);
      }
    };
  const handleReset = () => {
    // console.log("remove",row);
    handleResetBank()
  };

  const handleEdit = (row, type = null) => {
    setSelectedRow(row);
      console.log('rem',row)
      remToggle(row);
  };
  const handleUpdate = (e) => {
    // toggle();
    let copy = JSON.parse(JSON.stringify(records));

    let found = copy.find((i) => i.openingBalance == e.openingBalance);
    if (found) {
      found.openingBalance = e.openingBalance;
      found.date = e.date;
      found.bankName = e.bankName;
    }
    setRecords(copy);
  };

  const onSuccess = (e) => {
    editToggle();
    // getBankRecords();
  };
  const editToggle = (row) => {
    setSelectedRow(row)
    setEditModal((prev) => !prev);
  };

  const handleRemove = (row) => {
    console.log("remove",row);
    deleteBankRecordsDetails(row)
  };
  const deleteBankRecordsDetails = async (row) => {
    try {
      setLoading(true);
      let { data } = await Repo.banks({
        request: {
          method: "deleteBankDetails",
          data: {
            _id: selectedRow._id,
          },
        },
      });
      setLoading(false);
      if (data.response.status.statusCode == 200) {
        // setRecords(data.response.data.banks);
        getBankDetails() 
        remToggle() 
      }
    } catch (err) {
      console.log("err:", err);
      setLoading(false);
    }
  };

  const getBankDetails = async () => {
    try {
      setLoading(true);
      let { data } = await Repo.banks({
        request: {
          method: "getBankDetailsByBank",
          data: {
            bankId: location?.state?.bank?._id,
          },
        },
      });
      setLoading(false);
      if (data.response.status.statusCode == 200) {
        setBankDetails(data.response.data.banksDetails);
      }
    } catch (err) {
      console.log("err:", err);
      setLoading(false);
    }
  };


  
  const getBankRecords = async () => {
    try {
      setLoading(true);
      let { data } = await Repo.banks({
        request: {
          method: "getBanksByCompany",
          data: {
            company_code: localStorage.getItem("companyCode"),
          },
        },
      });
      setLoading(false);
      if (data.response.status.statusCode == 200) {
        setRecords(data.response.data.banks);
      }
    } catch (err) {
      console.log("err:", err);
      setLoading(false);
    }
  };

  const widToggle = () => {
    setModal((prev) => !prev);
  };

  const toggle = () => {
    setAddModal((prev) => !prev);
  };

  const handleAdd = (amount) => {
    widToggle();
    setBalance((prev) => prev + amount);
    getBankDetails();
  };

  return (
    <Box>
      <Header sx={{ mt: { md: "0px", xs: "30px" } }}>
        <TopGrid container alignItems="center">
          <Grid item md={9} xs={12}>
            <Box sx={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
              <Typography variant="h5" sx={{ color: "white" }}>
                <Link to={`/inventory/admin/bank-accounts`}>
                  <ButtonAdd
                    variant="contained"
                    sx={{ ml: 0, textTransform: "none" }}
                  >
                    <img src={BackIcon} style={{ marginRight: "8px" }} /> Back
                  </ButtonAdd>
                </Link>
              </Typography>
              <Box>
                <ButtonAdd
                  variant="contained"
                  sx={{ ml: 0, textTransform: "none" }}
                  onClick={widToggle}
                >
                  <PaymentsIcon sx={{ mr: 0.8 }} /> Deposit/Withdraw
                </ButtonAdd>
              </Box>
              <Box>
                <ButtonAdd
                  variant="contained"
                  sx={{ ml: 0, textTransform: "none" }}
                  onClick={resetToggle}
                >
                  <PaymentsIcon sx={{ mr: 0.8 }} /> Reset Bank
                </ButtonAdd>
              </Box>
              {/* <ButtonAdd
                variant="contained"
                sx={{ textTransform: "none", ml: 0 }}
                onClick={toggle}
              >
                <AddCircleOutlineIcon sx={{ mr: "8px" }} /> Add Cash
              </ButtonAdd> */}
            </Box>
          </Grid>
          <Grid item md={3} xs={12}>
            <CashBox>
              <Stack>
                <Typography>{location?.state?.bank?.bankName}</Typography>
                <Typography sx={{ color: "#4EAF51" }}>{totalSumOfRecords}</Typography>
              </Stack>
              <PaymentsIcon sx={{ color: "#767676" }} />
            </CashBox>
          </Grid>
        </TopGrid>
      </Header>
      <BodyContainer
        sx={{ position: "relative", top: { md: "0px", xs: "40px" } }}
      >
        {!loading && (
          <DataTable
            title={
              <DTtitle>
                {location?.state?.bank?.bankName} Transaction-Details
              </DTtitle>
            }
            columns={columns}
            data={bankDetails}
            highlightOnHover={true}
            pointerOnHover={true}
          />
        )}
      </BodyContainer>
      {loading && (
        <Box sx={{ mt: 2, display: "flex", justifyContent: "center" }}>
          <Loader loading={true} />
        </Box>
      )}

      {addModal && <AddCash onClose={toggle} />}
      {modal && (
        <AddDeposit
          onClose={widToggle}
          onSuccess={handleAdd}
          bank={location?.state?.bank || null}
        />
      )}
{editModal && (
        <UpdateBankDetails
          onClose={editToggle}
          onSuccess={onSuccess}
          onUpdate={handleUpdate}
          row={selectedRow}
          getBankDetails={   getBankDetails}
          getBankRecords={getBankRecords}
        />
      )}
{remModal && (
        <DeleteDialog
          open={true}
          onClose={remToggle}
          onClickYes={handleRemove}
        />
      )}

{resetModal && (
        <ResetDialog
          open={true}
          onClose={resetToggle}
          onClickYes={handleReset}
        />
      )}
    </Box>
  );
}

export default BankDetails;
